var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 114,
    viewBox: "0 0 264 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1255_67188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6398 90.5587C82.5964 90.5587 81.5419 90.4462 80.4897 90.2182C75.8877 89.2188 72.1406 86.1951 70.21 81.922L52.5305 42.7833C52.3268 42.3326 52.5288 41.8025 52.9816 41.599C53.4334 41.3965 53.9665 41.5973 54.1701 42.0487L71.8498 81.1867C73.5439 84.9367 76.8328 87.5907 80.8724 88.4677C84.8401 89.3278 88.8563 88.3061 91.89 85.6617C92.0556 85.5176 92.2206 85.3695 92.3869 85.2184C92.7526 84.8836 93.3209 84.9094 93.6569 85.2745C93.9922 85.6396 93.967 86.2064 93.6008 86.5398C93.4241 86.7014 93.2485 86.8576 93.073 87.0104C90.4118 89.3306 87.0895 90.5587 83.6398 90.5587Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.807 37.2529L177.79 37.5188L177.792 37.5193C177.972 37.5681 178.079 37.7534 178.03 37.933C177.981 38.1128 177.795 38.2189 177.615 38.1701H177.614L176.627 37.9021C176.447 37.8531 176.341 37.6681 176.39 37.4887C176.44 37.3093 176.625 37.2036 176.805 37.2524L176.807 37.2529Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.09 38.1166L181.078 38.3626L181.08 38.3631C181.263 38.4084 181.373 38.5925 181.328 38.774C181.282 38.9555 181.098 39.0661 180.916 39.0206H180.915L179.923 38.7725C179.741 38.727 179.631 38.5432 179.676 38.3619C179.722 38.1806 179.906 38.0705 180.088 38.116L180.09 38.1166Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.39 38.9123L184.383 39.1372L184.386 39.1377C184.57 39.1794 184.685 39.362 184.643 39.5454C184.601 39.7288 184.418 39.8437 184.234 39.8021L184.234 39.802L183.237 39.575C183.053 39.5331 182.938 39.3509 182.98 39.1677C183.022 38.9844 183.205 38.8701 183.389 38.9118L183.39 38.9123Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.706 39.6368L187.704 39.8395L187.707 39.8401C187.893 39.8778 188.012 40.0587 187.974 40.2439C187.936 40.4292 187.755 40.5487 187.569 40.511L187.569 40.5108L186.567 40.306C186.381 40.2681 186.261 40.0873 186.3 39.9025C186.338 39.7176 186.519 39.5983 186.705 39.6362L186.706 39.6368Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.038 40.286L191.041 40.4658L191.043 40.4661C191.231 40.4999 191.356 40.6788 191.322 40.8658C191.288 41.0529 191.108 41.1773 190.921 41.1435H190.92L189.913 40.9618C189.726 40.9281 189.601 40.7492 189.635 40.5625C189.67 40.3758 189.849 40.2518 190.036 40.2857L190.038 40.286Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.384 40.857L194.39 41.0108L194.393 41.0113C194.582 41.0402 194.712 41.2169 194.683 41.4056C194.654 41.5944 194.477 41.724 194.287 41.6951L194.287 41.6949L193.275 41.5392C193.086 41.5101 192.956 41.3336 192.986 41.1452C193.015 40.9568 193.192 40.8276 193.381 40.8566L193.384 40.857Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.742 41.3362L197.752 41.4613L197.755 41.4616C197.946 41.4853 198.082 41.6589 198.058 41.8493C198.034 42.0398 197.86 42.175 197.669 42.1514H197.668L196.653 42.0244C196.462 42.0006 196.326 41.8272 196.35 41.6369C196.374 41.4467 196.549 41.3119 196.739 41.3357L196.742 41.3362Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.112 41.7201L201.125 41.8167L201.128 41.817C201.321 41.8354 201.462 42.006 201.444 42.198C201.426 42.3901 201.254 42.5309 201.062 42.5124H201.061L200.042 42.4143C199.85 42.3958 199.709 42.2254 199.728 42.0335C199.746 41.8418 199.917 41.7014 200.11 41.72L200.112 41.7201Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.493 42.0086L204.508 42.0766L204.511 42.0767C204.705 42.0897 204.852 42.257 204.839 42.4505C204.826 42.6439 204.658 42.7901 204.464 42.7773H204.464L203.442 42.7079C203.248 42.6948 203.102 42.5275 203.115 42.3344C203.128 42.1413 203.296 41.9954 203.49 42.0086H203.493Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.88 42.2014L207.897 42.2405L207.9 42.2407C208.095 42.2481 208.247 42.4121 208.24 42.6068C208.232 42.8014 208.068 42.9532 207.872 42.9457H207.872L206.849 42.9054C206.654 42.8976 206.502 42.7339 206.51 42.5395C206.517 42.3452 206.682 42.1938 206.877 42.2014H206.88Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.271 42.2976L211.288 42.3075H211.292C211.488 42.3094 211.646 42.4696 211.644 42.6653C211.642 42.8611 211.481 43.0182 211.284 43.0163H211.284L210.26 43.0053C210.064 43.0032 209.907 42.843 209.909 42.6475C209.911 42.4519 210.072 42.2952 210.268 42.2973L210.271 42.2976Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.663 42.2965L214.681 42.2768H214.684C214.881 42.273 215.044 42.4292 215.048 42.626C215.052 42.8227 214.895 42.9851 214.698 42.989H214.697L213.674 43.0078C213.477 43.0114 213.314 42.8552 213.31 42.6588C213.306 42.4625 213.463 42.3003 213.66 42.2967L213.663 42.2965Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.053 42.1955L218.07 42.1453L218.073 42.1452C218.271 42.1355 218.44 42.2875 218.449 42.485C218.459 42.6824 218.306 42.8504 218.108 42.8601H218.108L217.085 42.9094C216.887 42.9189 216.719 42.7668 216.709 42.5697C216.7 42.3725 216.852 42.205 217.05 42.1955H217.053Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.439 41.9922L221.453 41.9111L221.457 41.9107C221.655 41.8948 221.829 42.0424 221.845 42.2403C221.861 42.4384 221.713 42.6116 221.514 42.6277H221.514L220.493 42.7083C220.294 42.7239 220.121 42.5765 220.105 42.3787C220.089 42.181 220.237 42.008 220.436 41.9922H220.439Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.816 41.6849L224.827 41.5717L224.831 41.5712C225.03 41.5489 225.209 41.6916 225.232 41.8899C225.254 42.0882 225.111 42.2671 224.912 42.2894H224.912L223.893 42.4022C223.695 42.4244 223.516 42.2816 223.493 42.0835C223.471 41.8854 223.614 41.707 223.813 41.6851L223.816 41.6849Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.182 41.2691L228.188 41.1227L228.192 41.1222C228.391 41.0933 228.576 41.2307 228.605 41.4291C228.634 41.6276 228.496 41.8118 228.297 41.8409H228.297L227.283 41.9873C227.084 42.016 226.899 41.8786 226.871 41.6803C226.842 41.4821 226.98 41.2981 227.178 41.2696L227.182 41.2691Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.531 40.7414L231.532 40.5608L231.535 40.5601C231.734 40.5241 231.925 40.6558 231.961 40.8541C231.997 41.0524 231.865 41.2422 231.666 41.2782H231.666L230.657 41.4591C230.458 41.4948 230.268 41.3633 230.232 41.1652C230.197 40.9671 230.329 40.7776 230.527 40.742L230.531 40.7414Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.858 40.0977L234.852 39.8813L234.856 39.8804C235.054 39.8372 235.25 39.9624 235.294 40.1602C235.337 40.358 235.211 40.5533 235.013 40.5966H235.012L234.011 40.8137C233.813 40.8568 233.617 40.7313 233.574 40.5339C233.531 40.3363 233.657 40.1413 233.855 40.0984L233.858 40.0977Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.159 39.3334L238.144 39.0797L238.148 39.0787C238.345 39.0278 238.547 39.1462 238.598 39.3431C238.649 39.54 238.531 39.7408 238.333 39.7919L238.333 39.792L237.34 40.0469C237.142 40.0976 236.941 39.9793 236.89 39.7825C236.839 39.5858 236.958 39.3853 237.156 39.3346L237.159 39.3334Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.428 38.4424L241.401 38.1497L241.405 38.1484C241.601 38.0893 241.808 38.2 241.868 38.3957C241.927 38.5912 241.816 38.7978 241.62 38.8568L241.619 38.857L240.637 39.1513C240.441 39.2101 240.234 39.0994 240.176 38.9039C240.116 38.7085 240.228 38.5024 240.424 38.4436L240.428 38.4424Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.656 37.4196L244.615 37.0862L244.62 37.0846C244.814 37.017 245.027 37.1194 245.095 37.3132C245.163 37.5071 245.06 37.7191 244.866 37.7866L244.865 37.7867L243.896 38.1224C243.702 38.1897 243.49 38.0873 243.422 37.8937C243.355 37.7001 243.457 37.4885 243.652 37.4212L243.656 37.4196Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.682 67.5237C128.682 67.5237 126.96 63.0079 124.949 63.4214C122.939 63.8351 120.739 65.3743 120.739 65.3743L117.508 69.7277C117.508 69.7277 126.577 73.2874 129.766 71.2473C129.766 71.2473 139.029 72.8422 150.726 70.9296C149.032 67.3675 148.023 63.8012 147.431 61.0329C141.506 64.3746 135.125 66.8706 128.682 67.5237Z",
    fill: "url(#paint0_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.747 34.7689C177.747 34.7689 164.485 51.4133 147.431 61.0329C148.023 63.8012 149.032 67.3675 150.726 70.9296C159.573 69.483 169.812 66.0307 178.493 58.3594L177.747 34.7689Z",
    fill: "#1B3234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.621066 42.445L26.9481 108.421C28.288 111.779 31.7635 113.784 35.353 113.269L104.391 108.189L79.5241 38.0309C78.8617 36.2953 77.174 35.1639 75.3109 35.2067C63.2066 35.4845 19.1213 36.5694 3.35043 37.9679C1.1609 38.162 -0.211512 40.4177 0.621066 42.445Z",
    fill: "url(#paint1_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0267 110.274L6.72336 43.7056C6.19256 42.3621 7.16613 40.9022 8.61494 40.8697L73.6288 38.4109C75.3038 38.3475 76.8358 39.3467 77.4477 40.9018L101.259 105.794L33.0267 110.274Z",
    fill: "url(#paint2_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.545 42.4449L237.218 108.421C235.878 111.779 232.403 113.783 228.813 113.269L159.775 108.455L184.642 38.0306C185.305 36.2951 186.993 35.1637 188.856 35.2064C200.96 35.4843 245.045 36.5691 260.816 37.9677C263.006 38.162 264.378 40.4176 263.545 42.4449Z",
    fill: "url(#paint3_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.14 110.274L257.443 43.7056C257.974 42.3621 257 40.9022 255.551 40.8697L190.538 38.4109C188.862 38.3475 187.33 39.3467 186.719 40.9018L162.907 105.794L231.14 110.274Z",
    fill: "#FFB8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3511 36.9701L79.1745 59.0046C81.513 59.8065 83.7395 60.4303 85.8596 60.896C87.1858 56.6416 90.1058 51.4201 92.4969 47.5377C83.7117 44.443 78.3511 36.9701 78.3511 36.9701Z",
    fill: "url(#paint4_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.213 36.5952C110.161 49.5604 100.407 50.3236 92.4972 47.5375C90.1061 51.4199 87.1861 56.6416 85.8599 60.8958C118.042 67.9658 125.62 38.4849 125.62 38.4849L122.213 36.5952Z",
    fill: "url(#paint5_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.656 35.218C124.656 35.218 126.044 33.7326 128.614 34.1994C131.183 34.6662 133.47 35.5557 135.071 34.1994C136.671 32.8431 137.234 34.6633 137.234 34.6633L132.441 38.2945L124.656 35.218Z",
    fill: "url(#paint6_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.789 37.7575C121.789 37.7575 122.74 33.7943 125.607 34.3376C128.473 34.8807 134.981 38.4072 136.658 37.7575C138.335 37.108 140.479 35.5531 141.58 36.1026L139.642 38.5034C139.642 38.5034 144.624 35.6394 145.481 37.3992L137.192 42.0477C137.192 42.0477 125.063 40.8378 121.789 37.7575Z",
    fill: "url(#paint7_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6329 109.591C36.6329 109.591 32.5211 51.0938 62.4972 32.9042C62.4972 32.9042 70.8777 27.3911 81.3206 38.0678C91.7633 48.7446 88.4004 59.8367 79.6369 70.2321C70.8732 80.6275 61.9471 99.1968 64.0714 109.591H36.6329Z",
    fill: "#FC635F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6046 16.9704C77.5967 17.668 67.6147 31.796 67.6147 31.796C67.6147 31.796 69.4065 35.3123 77.9601 38.1669L85.3435 23.0401L77.6046 16.9704Z",
    fill: "url(#paint8_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6792 65.4767C73.6792 65.4767 92.6175 81.2816 113.068 74.3851C114.336 73.9574 115.723 74.0504 116.907 74.6734L122.787 77.7675C125.254 79.0662 128.31 78.2136 129.742 75.8268C130.559 74.4653 131.256 72.9103 131.395 71.4206L119.891 66.7799L120.739 65.3742C120.739 65.3742 115.122 64.9 113.652 68.9113C113.652 68.9113 102.953 73.3455 84.9113 53.5708C84.9113 53.5706 76.7241 60.5077 73.6792 65.4767Z",
    fill: "url(#paint9_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.66 65.4077C72.5792 65.4077 72.4976 65.3845 72.4258 65.3361C64.4283 59.9517 60.6662 51.2605 60.629 51.1735C60.5387 50.9612 60.6382 50.7164 60.8511 50.6262C61.0642 50.5363 61.3102 50.6354 61.4005 50.8475C61.4368 50.9325 65.109 59.4023 72.8949 64.6443C73.0868 64.7734 73.1371 65.0329 73.0076 65.2239C72.9265 65.3432 72.7945 65.4077 72.66 65.4077Z",
    fill: "url(#paint10_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5376 53.3975C84.4 53.3975 84.2653 53.3301 84.1851 53.2062C84.1611 53.169 81.7233 49.3873 77.0817 41.1055C75.6681 38.5834 73.813 36.9867 71.5672 36.3602C67.8433 35.3214 64.251 37.3131 64.215 37.3333C64.014 37.447 63.7584 37.3767 63.6441 37.1764C63.5299 36.976 63.6002 36.7213 63.8009 36.6075C63.9594 36.518 67.7214 34.425 71.7855 35.554C74.2574 36.2414 76.2854 37.9721 77.8132 40.6984C82.4397 48.953 84.8654 52.7169 84.8893 52.7541C85.0149 52.9479 84.9586 53.2062 84.7642 53.3311C84.6942 53.3761 84.6154 53.3975 84.5376 53.3975Z",
    fill: "url(#paint11_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4634 8.875C85.4634 8.875 89.0151 17.005 89.2537 21.2724C89.4922 25.5396 90.4149 28.3085 85.4634 29.1679C80.5119 30.0271 76.3406 27.5691 74.0808 23.3186C74.0808 23.3186 70.54 16.7687 71.3344 14.0864C72.1286 11.404 85.4634 8.875 85.4634 8.875Z",
    fill: "url(#paint12_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7731 20.2625L76.0551 20.1386C76.414 19.981 76.5675 19.5554 76.3872 19.2083C75.689 17.8639 74.3277 14.7833 76.0861 14.0647C78.3524 13.1386 87.3291 11.3144 89.2659 8.14052C91.1272 5.09 89.4781 1.15241 86.9992 0.0324452C86.8334 -0.0424725 86.6377 0.0170465 86.5527 0.177436L86.3462 0.566905C86.2049 0.833529 85.8097 0.793042 85.7255 0.503406C85.6447 0.225363 85.2735 0.171381 85.1196 0.416896C84.5243 1.36643 82.9171 2.90597 78.6188 3.6965C72.5101 4.81992 68.4716 7.28321 68.371 11.4893C68.3646 11.7565 68.0793 11.9051 67.8503 11.766C67.3992 11.4921 66.6776 11.3635 65.7129 12.1717C64.0352 13.5773 64.7218 17.2236 68.3993 20.223C68.574 20.3654 68.5726 20.6373 68.3835 20.7601C67.7168 21.1925 66.7229 22.2216 69.2982 23.5933C71.962 25.0122 73.9511 24.8958 74.717 24.7698C74.9075 24.7385 75.0304 24.5546 74.9888 24.3667L74.1713 20.6698C74.1249 20.4606 74.2849 20.2623 74.4998 20.2623H75.7731V20.2625Z",
    fill: "#0B0754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9268 21.0425C75.9268 21.0425 74.572 15.8491 72.2352 17.3053C69.8984 18.7614 73.4477 23.1243 75.3264 23.3186L75.9268 21.0425Z",
    fill: "url(#paint13_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.907 74.6736C116.907 74.6736 121.72 79.3644 122.648 78.6814C122.979 78.4385 123.813 77.5561 124.622 76.5734C125.192 75.8799 125.251 74.9003 124.762 74.1476L123.627 72.4024C122.545 70.7393 120.23 70.3905 118.73 71.6916C117.973 72.3477 117.286 73.2979 116.907 74.6736Z",
    fill: "url(#paint14_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.744 108.729C192.744 108.729 192.712 87.6537 180.415 65.8909C176.568 59.0834 175.2 51.1601 176.4 43.4398L177.747 34.7689C177.747 34.7689 194.623 29.0782 213.331 34.5292C213.331 34.5292 239.27 55.8631 221.934 110.427L192.744 108.729Z",
    fill: "#1B3234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.775 23.0056L185.152 33.4817C185.428 34.1433 186.025 34.615 186.734 34.7361C189.257 35.1672 195.36 35.8406 199.367 33.2149C199.844 32.9021 199.966 32.2551 199.639 31.7878L191.555 20.2217L180.775 23.0056Z",
    fill: "url(#paint15_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.413 72.9353C190.81 73.0936 190.511 73.7686 190.799 74.3193L203.459 98.5089C203.673 98.9174 204.146 99.1194 204.59 98.9915L246.002 87.0771C246.518 86.9289 246.815 86.392 246.666 85.8781L239.533 61.2705C239.386 60.7653 238.862 60.4689 238.352 60.603L191.413 72.9353Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.085 70.0929C193.492 70.2337 193.155 70.859 193.366 71.4289L203.5 98.8601C203.684 99.3589 204.224 99.6313 204.737 99.4837L246.024 87.6053C246.538 87.4575 246.849 86.9385 246.736 86.4175L241.014 60.0163C240.894 59.4609 240.339 59.1127 239.784 59.2443L194.085 70.0929Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.68 67.324C196.956 67.4337 196.479 68.1343 196.645 68.8452L203.528 98.458C203.69 99.1577 204.409 99.5781 205.101 99.3788L245.763 87.6804C246.416 87.4923 246.801 86.8205 246.632 86.1642L240.378 61.992C240.217 61.3697 239.61 60.9697 238.972 61.0664L197.68 67.324Z",
    fill: "url(#paint16_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.596 78.6168C233.752 54.8614 215.38 36.5952 215.38 36.5952L204.449 49.2929C212.748 59.6003 216.693 69.0455 218.495 76.4637C220.885 75.7704 226.639 74.6747 230.596 78.6168Z",
    fill: "#1B3234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.494 76.7422C218.368 76.7422 218.254 76.6567 218.223 76.5294C215.988 67.3278 211.28 58.2228 204.231 49.4673C204.134 49.3472 204.154 49.1721 204.274 49.0761C204.394 48.9797 204.57 48.9992 204.667 49.1188C211.768 57.9385 216.511 67.1167 218.766 76.3984C218.802 76.5477 218.71 76.6982 218.56 76.7346C218.538 76.7396 218.516 76.7422 218.494 76.7422Z",
    fill: "#3E3E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.495 76.4638C220.17 83.3586 219.994 88.5028 219.739 90.959C219.643 91.885 218.896 92.6081 217.964 92.673C216.905 92.7469 215.465 92.8438 214.177 92.9176C212.762 92.9988 211.191 92.1075 210.141 91.3625C209.604 90.9822 208.911 91.5745 209.21 92.1586C209.994 93.6872 211.984 95.0475 213.355 95.8477C213.854 96.1387 213.761 96.882 213.204 97.039L207.339 98.6956C216.976 107.742 223.339 97.6201 223.339 97.6201C227.593 91.0705 229.792 84.6656 230.595 78.6166C226.639 74.6746 220.885 75.7703 218.495 76.4638Z",
    fill: "url(#paint17_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.145 7.67469C184.961 7.84702 177.389 22.6653 177.389 22.6653L185.972 26.7941L195.243 13.8119C195.243 13.8119 188.222 4.78854 185.145 7.67469Z",
    fill: "url(#paint18_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.343 15.3696L187.062 22.4802C186.997 22.5882 186.92 22.6856 186.827 22.7714C186.318 23.2441 184.574 24.6187 183.226 22.747C182.077 21.1517 180.999 19.7015 179.844 19.1034C179.17 18.754 178.34 19.0329 177.998 19.7093C177.292 21.1023 175.926 23.9415 175.068 26.6341C174.853 27.3088 175.202 28.0335 175.861 28.2994C177.599 29.001 181.034 30.2699 184.082 30.6891C184.582 30.758 185.078 30.5476 185.376 30.1407C186.687 28.3504 190.384 23.3477 191.645 22.0956C192.817 20.9322 194.98 21.3708 195.955 21.6499C196.325 21.7558 196.719 21.7047 197.048 21.507C198.037 20.9135 199.763 19.4354 198.184 16.9332C197.792 16.311 197.992 15.4824 198.608 15.0784C199.712 14.3546 200.91 12.9963 199.769 10.7965C198.613 8.56954 196.55 8.36953 195.144 8.54082C194.523 8.6166 193.891 8.29167 193.653 7.71448C193.547 7.45771 193.337 7.23884 192.946 7.15995C192.21 7.01115 191.726 6.33983 191.871 5.60501C192.119 4.34491 191.932 2.70779 189.913 1.6015C186.21 -0.427338 182.966 2.87856 182.141 5.6692C181.316 8.46002 185.457 10.4323 188.061 10.7614C189.974 11.0031 191.023 13.0838 191.446 14.1714C191.599 14.5661 191.561 15.0066 191.343 15.3696Z",
    fill: "#0B0754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.038 24.7068C190.038 24.7068 191.684 19.9055 193.792 20.0818C195.9 20.2581 197.559 22.3504 194.947 24.7028C191.697 27.6287 190.038 24.7068 190.038 24.7068Z",
    fill: "url(#paint19_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.865 111.122C127.865 112.352 126.865 113.349 125.631 113.349H34.8337C32.9579 113.349 31.4374 111.834 31.4374 109.965L30.0093 108.311L124.286 107.506C126.271 107.533 127.865 109.144 127.865 111.122Z",
    fill: "url(#paint20_linear_1255_67188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.301 111.122C136.301 112.352 137.301 113.349 138.536 113.349H229.332C231.208 113.349 232.729 111.834 232.729 109.965L234.157 108.311L139.88 107.506C137.896 107.533 136.301 109.144 136.301 111.122Z",
    fill: "url(#paint21_linear_1255_67188)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1255_67188",
    x1: 120.105,
    y1: 75.8578,
    x2: 139.178,
    y2: 66.2876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1255_67188",
    x1: 0.375026,
    y1: 74.2773,
    x2: 104.391,
    y2: 74.2773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1255_67188",
    x1: 85.7872,
    y1: 93.5706,
    x2: -28.5158,
    y2: 24.0339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1255_67188",
    x1: 159.775,
    y1: 74.2772,
    x2: 263.791,
    y2: 74.2772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1255_67188",
    x1: 94.0165,
    y1: 36.8218,
    x2: 76.6791,
    y2: 54.5758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1255_67188",
    x1: 78.8537,
    y1: 65.8181,
    x2: 130.07,
    y2: 36.3359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1255_67188",
    x1: 78.5428,
    y1: 65.2781,
    x2: 129.759,
    y2: 35.7959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1255_67188",
    x1: 79.7583,
    y1: 67.3903,
    x2: 130.975,
    y2: 37.9081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1255_67188",
    x1: 80.6862,
    y1: 19.9554,
    x2: 72.1394,
    y2: 36.3299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1255_67188",
    x1: 73.7879,
    y1: 49.3721,
    x2: 110.689,
    y2: 74.1471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1255_67188",
    x1: 60.5957,
    y1: 58.0002,
    x2: 73.0795,
    y2: 58.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1255_67188",
    x1: 63.5893,
    y1: 44.3089,
    x2: 84.9564,
    y2: 44.3089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1255_67188",
    x1: 74.0204,
    y1: 6.72107,
    x2: 86.9751,
    y2: 28.0423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1255_67188",
    x1: 67.9072,
    y1: 10.4356,
    x2: 80.8619,
    y2: 31.7569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1255_67188",
    x1: 119.93,
    y1: 75.5092,
    x2: 139.003,
    y2: 65.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1255_67188",
    x1: 189.63,
    y1: 24.521,
    x2: 193.769,
    y2: 43.9053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA4A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1255_67188",
    x1: 220.872,
    y1: 74.0787,
    x2: 232.159,
    y2: 124.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1255_67188",
    x1: 238.041,
    y1: 53.1537,
    x2: 220.826,
    y2: 86.3769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1255_67188",
    x1: 176.638,
    y1: 11.0685,
    x2: 189.807,
    y2: 19.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1255_67188",
    x1: 189.775,
    y1: 21.2701,
    x2: 193.951,
    y2: 24.4109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1255_67188",
    x1: 78.6331,
    y1: 94.7616,
    x2: 79.3382,
    y2: 129.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1255_67188",
    x1: 184.88,
    y1: 92.6121,
    x2: 185.585,
    y2: 127.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1255_67188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263.416,
    height: 113.349,
    fill: "white",
    transform: "translate(0.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature01);
export default __webpack_public_path__ + "static/media/feature_01.47f2647e5fcb8d14600ac7fc29c85339.svg";
export { ForwardRef as ReactComponent };